import { FormFieldAutocomplete } from '@/global/components/Form'
import { funcao_api } from '@/service/api'
import { useState } from 'react'

export default function AutocompleteFuncao() {
    const { data = [] } = funcao_api.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })
    const [digitando, setDigitando] = useState<string>('')

    const handleInputChange = (inputValue: string) => {
        setDigitando(inputValue.trim())
    }

    const criarNovo = () => {
        if (digitando && !data.includes(digitando)) {
            funcao_api.setQueryData<string[]>(
                undefined,
                (prev: string[] | undefined) =>
                    prev ? [digitando, ...prev] : [digitando],
            )
        }
        setDigitando('')
    }

    return (
        <FormFieldAutocomplete
            name="funcao"
            label="Cargo/Função"
            options={data}
            onInputChange={handleInputChange}
            creatableOption={
                digitando.length > 0 && !data.includes(digitando)
                    ? {
                          label: `Criar: "${digitando}"`,
                          value: digitando,
                          onClick: criarNovo,
                      }
                    : undefined
            }
            noOptionsText="Nenhum cargo/função encontrado, comece a digitar para criar um novo."
            required
        />
    )
}
